// Client\client-vite\src\pages\Marketplace\AfricarsApp\AfricarsAppPage.tsx

export const AfricarsAppPage = () => {
    return (
        <div className="">
            <h2>AfricarsAppPage</h2>
        </div>
    )
}

export default AfricarsAppPage